<template>
	<div v-if="isVisible" class="cookies-modal">
		<div class="cookies-modal__inner _modal-inner">
			<div class="cookies-modal__title _md">{{ $t('About Cookies') }}</div>
			<div class="cookies-modal__about">
				<p>
					{{
						$te('This Website stores cookies on your computer')
							? $t('This Website stores cookies on your computer')
							: `This Website stores cookies on your computer. These cookies collect information about how you
									navigate our Website and allow us to remember you. We use this information to improve and customise your
									browsing experience and for analytics and metrics about our visitors on this Website.`
					}}
				</p>
				<p>
					{{
						$te('Before you proceed with using our Website')
							? $t('Before you proceed with using our Website')
							: 'This Website stores cookies on your computer. These cookies collect information about how you navigate our Website and allow us to remember you. We use this information to improve and customise your browsing experience and for analytics and metrics about our visitors on this Website.'
					}}
				</p>
				<p>
					{{
						$te('You can either accept or decline use of Cookies')
							? $t('You can either accept or decline use of Cookies')
							: `You can either accept or decline use of Cookies. If you opt to decline Cookies your information won't
									be tracked when you visit this Website.`
					}}
				</p>
				<router-link
					v-if="cookiePage && cookiePage.slug"
					:to="{ name: 'TextPage', params: { slug: cookiePage.slug } }"
					class="cookies-modal__link _link-primary"
				>
					{{ cookiePage.title }}
				</router-link>
			</div>
			<div class="cookies-modal__actions">
				<BaseButton
					class="cookies-modal__submit _btn-primary"
					@click="acceptCookies"
				>
					{{ $t('Accept') }}
				</BaseButton>
				<BaseButton
					class="cookies-modal__submit _btn-bordered"
					@click="declineCookies"
				>
					{{ $t('Decline') }}
				</BaseButton>
			</div>
		</div>
	</div>
</template>

<script>
import { COOKIE_PAGE } from '@/store/modules/staticPages';
import { mapGetters } from 'vuex';
import BaseButton, { ButtonThemes } from './base/BaseButton.vue';

export default {
	name: 'CookiesModal',
	components: { BaseButton },
	data() {
		return {
			ButtonThemes,
			isVisible: false,
		};
	},
	computed: {
		...mapGetters('staticPages', ['getCookiePage']),
		cookiePage() {
			return this.getCookiePage;
		},
	},
	created() {
		this.COOKIE_PAGE = COOKIE_PAGE;
	},
	methods: {
		showModal() {
			const cookiesAccepted = localStorage.getItem('cookiesAccepted');
			if (!cookiesAccepted || cookiesAccepted !== 'true') {
				this.isVisible = true;
			}
		},
		acceptCookies() {
			localStorage.setItem('cookiesAccepted', 'true');
			this.isVisible = false;
		},
		declineCookies() {
			localStorage.setItem('cookiesAccepted', 'false');
			this.isVisible = false;
		},
	},
	mounted() {
		this.showModal();
	},
};
</script>

<style lang="scss" scoped>
@use '@/assets/styles/mixins' as *;
@use '@/assets/styles/media' as *;
@use '@/assets/styles/components/classes' as *;

.cookies-modal {
	&__inner {
		z-index: var(--modal-z-index);
		max-width: 510px;
		position: fixed;
		left: 50%;
		bottom: 0px;
		transform: translate(-50%, 0px);
	}
	&__title {
		text-align: center;
		&:not(:last-child) {
			@include adaptiveValue('margin-bottom', 20, 15);
		}
	}
	&__about {
		text-align: center;
		color: var(--secondary-color);
		&:not(:last-child) {
			@include adaptiveValue('margin-bottom', 20, 15);
		}
	}
	&__link {
		padding: 5px 0px;
		display: inline-block;
	}
	&__actions {
		display: flex;
		gap: 10px;
		@media (max-width: $md5) {
			flex-wrap: wrap;
		}
	}
	&__submit {
		text-transform: uppercase;
		flex: 0 1 50%;
		@media (max-width: $md5) {
			flex: 1 1 100%;
		}
	}
}
</style>
